import {withStyles} from 'common/util/react';
import {react2panel} from 'common/util/react2panel';

import {InputLabelReact} from './';
import css from './index.module.styl?inline';

export const InputLabelEl = react2panel(`mp-input-label`, withStyles(InputLabelReact, css));
